import { Button, Dropdown, Grid, Tag, Avatar } from "antd";
import SiteLogo from "../../../../assets/images/site-logo.svg";
import SVGIcon from "../../../../utils/SVGIcon";
import Logout from "../../../app_pages/Auth/Logout";
import UserProfileModal from "./UserProfileModal";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { CONSTANT } from "../../../../config/Constant";
import AvatarImg from "../../../../assets/images/avatar.png";

const HeaderComponent = ({ collapsed, setCollapsed }) => {
  const { userProfileData } = useSelector(
    (state) => state.auth
  );
  const isTenantVerified = localStorage.getItem("isTenantVerified") || "false";
  const isAdmin = localStorage.getItem("isa") || "false";
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const [logoutModal, setLogoutModal] = useState(false);
  const [profileModal, setProfileModal] = useState(false);
  const [profileActiveTab, setProfileActiveTab] = useState("1");

  const openLogoutModal = () => {
    setLogoutModal(true);
  };

  const closeLogoutModal = () => {
    setLogoutModal(false);
  };

  const openProfileModal = (tab = "1") => {
    setProfileActiveTab(tab);
    setProfileModal(true);
  };

  const closeProfileModal = () => {
    setProfileModal(false);
  };

  const getInitials = (name) => {
    if (!name) return "U";
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) {
      return parts[0].substring(0, 2).toUpperCase();
    }
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  };

  const userName = userProfileData?.userName || "";
  const userEmail = userProfileData?.email || "";
  const tenantName = userProfileData?.tenantName || "";
  const roleTitle =
    userProfileData?.roleName ||
    userProfileData?.role?.name ||
    (isAdmin === "true" ? "Super Admin" : "User");

  const profileItems = [
    {
      key: "user-card",
      className: "dropdownUserHeader",
      label: (
        <div className="dropdownProfileCard">
          <Avatar size={42} className="dropdownAvatar initialsAvatar">
            {getInitials(userName)}
          </Avatar>
          <div className="dropdownUserInfo">
            <span className="dropdownFullName">{userName}</span>
            <span className="dropdownUserEmail">{userEmail}</span>
            <div className="dropdownBadges">
              <Tag color="blue" className="dropdownRoleTag">
                <SVGIcon icon="userRole" size={12} />
                <span>{roleTitle}</span>
              </Tag>
            </div>
          </div>
        </div>
      ),
    },
    {
      type: "divider",
    },
    {
      key: "my-profile",
      className: "dropdownMenuItem",
      icon: <SVGIcon icon="user" size={16} />,
      label: "My Profile",
      onClick: () => openProfileModal("1"),
    },
    {
      key: "change-password",
      className: "dropdownMenuItem",
      icon: <SVGIcon icon="password" size={16} />,
      label: "Change Password",
      onClick: () => openProfileModal("2"),
    },
    {
      type: "divider",
    },
    {
      key: "logout",
      className: "dropdownMenuItem",
      icon: <SVGIcon icon="logout" size={16} />,
      label: "Logout",
      onClick: () => openLogoutModal(),
    },
  ];

  return (
    <>
      <Logout open={logoutModal} close={closeLogoutModal} />
      <UserProfileModal
        open={profileModal}
        close={closeProfileModal}
        activeTab={profileActiveTab}
      />
      <div
        className={`headerWrap ${
          (isAdmin === "true" || isTenantVerified === "true") && !collapsed
            ? "sidebarExpanded"
            : ""
        }`}
      >
        <div className="leftHeader">
          <div className="siteLogo">
            <Link to={CONSTANT.DEFAULT_ROUTE}>
              <img src={SiteLogo} alt="Site Logo" />
            </Link>
          </div>
          {(isAdmin === "true" || isTenantVerified === "true") && (
            <Button
              className="toggleMenu"
              type="primary"
              // onClick={handleMenuToggle}
              onClick={() => setCollapsed(!collapsed)}
            >
              <SVGIcon icon="toggle_menu" />
            </Button>
          )}
        </div>
        {userProfileData?.tenantName && (
          <span className="tenantName">{userProfileData.tenantName}</span>
        )}

        <div className="rightMenu">
          <ul>
            {/* <li>
              <AddModalComponent />
            </li> */}
            {/* <li>
              <Button
                className="iconBtn"
                // onClick={handleMenuToggle}
              >
                <SVGIcon icon="message" />
              </Button>
            </li>
            <li>
              <Dropdown
                menu={{
                  items: notificationItems,
                }}
                trigger={["click"]}
                placement="bottomRight"
                arrow={{
                  pointAtCenter: true,
                }}
              >
                <Link to={(e) => e.preventDefault()}>
                  <SVGIcon icon="notification" />
                </Link>
              </Dropdown>
            </li> */}
            <li>
              <Dropdown
                menu={{
                  items: profileItems,
                }}
                trigger={["click"]}
                placement="bottom"
                arrow={{
                  pointAtCenter: true,
                }}
                overlayClassName="profileDropdown"
              >
                <div className="userProfileHead">
                  <span className="name">
                    {isMobile ? (
                      <img src={AvatarImg} alt="Avatar" />
                    ) : (
                      `Welcome, ${userProfileData?.userName || "User"}!`
                    )}
                  </span>
                  {/*
                  <div className="userPhoto">
                    <img
                      src={AvatarImg}
                      // src={`data:image/jpeg;base64,${userProfileData?.photoUrl}`}
                      alt="User"
                    />
                  </div>
                     */}
                  <SVGIcon icon="dropdown_arrow" />
                </div>
                {/* <Link
                  to={(e) => e.preventDefault()}
                  className="userProfileHead"
                >
                  <div className="userPhoto">
                    <img src={AvatarImg} alt="User" />
                  </div>
                  <SVGIcon icon="dropdown_arrow" />
                </Link> */}
              </Dropdown>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default HeaderComponent;
